import axios from 'axios';

import { buildEndpoint, getAuthToken } from '@services/service';
import { CreateService, Service } from '@app-types/service.type';

const BASE_SUBSCRIPTIONS_URL = process.env
    .REACT_APP_SUBSCRIPTIONS_URL as string;

const createService = async (data: CreateService): Promise<Service | null> => {
    try {
        const endpoint = buildEndpoint(
            BASE_SUBSCRIPTIONS_URL,
            '/api/admin/services'
        );
        const response = await axios.post(endpoint, data, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data;
    } catch (err) {
        console.error('Error creating service:', err);
        return null;
    }
};

export { createService };
